import "@arco-design/web-react/es/Modal/style";
import _Modal from "@arco-design/web-react/es/Modal";
import "@arco-design/web-react/es/Button/style";
import _Button from "@arco-design/web-react/es/Button";
import React from 'react';
import styled from '@emotion/styled';
const Content = styled.div`
  img {
    width: 100%;
  }
  height: 400px;
  overflow: scroll;
`;
export function PreviewContent({
  content,
  title
}) {
  const [visible, setVisible] = React.useState(false);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_Button, {
    size: "mini",
    onClick: () => setVisible(true),
    type: "primary"
  }, "\u9884\u89C8"), /*#__PURE__*/React.createElement(_Modal, {
    title: title,
    visible: visible,
    style: {
      width: '400px'
    },
    onOk: () => setVisible(false),
    onCancel: () => setVisible(false),
    footer: null,
    autoFocus: false,
    focusLock: true
  }, /*#__PURE__*/React.createElement(Content, {
    dangerouslySetInnerHTML: {
      __html: content
    }
  })));
}